import { Button } from 'components/core';
import { IteroOrderAdditionalInfo } from 'components/ITeroOrderAdditionalInfo';
import ITeroTermsConditionsModal from 'components/ITeroTermsConditionsModal/ITeroTermsConditionsModal';
import { useState } from 'react';
import {
  Address,
  CreditCardClientData,
  DoctorProfile,
  IteroProposalClient,
  ScannerSubFundingSource,
} from 'types';
import { Styled } from './';
import { useI18n} from 'contexts/i18n';

const ITeroTermsAndConditions = ({
  onPlaceIteroOrder,
  additionalOrderInfo,
  selectedScannerSubFundingSource,
  selectedShippingAddress,
  selectedBillingAddress,
  doctorProfile,
  currentProposal,
  selectedCreditCard,
}: {
  onPlaceIteroOrder: (text: string) => void;
  additionalOrderInfo: IteroOrderAdditionalInfo;
  selectedScannerSubFundingSource: ScannerSubFundingSource;
  selectedShippingAddress: Address | undefined;
  selectedBillingAddress: Address | undefined;
  doctorProfile: DoctorProfile | undefined;
  currentProposal: IteroProposalClient;
  selectedCreditCard?: CreditCardClientData;
}) => {
  const [showTCAcceptedModal, setShowTCAcceptedModal] = useState(false);

  const handleReviewAndSubmit = () => {
    setShowTCAcceptedModal(true);
  };

  const handlePlaceIteroOrder = (approvedPdf: string) => {
    setShowTCAcceptedModal(false);
    onPlaceIteroOrder(approvedPdf);
  };
  
  const i18n = useI18n();

  return (
    <Styled.IteroTCContainer>
      <Styled.IteroTCText>
       {i18n['iTeroReviewAndSubmitDisclaimer']}
      </Styled.IteroTCText>

      <Styled.ButtonWrapper>
        <Button
          size="md"
          onClick={() => {
            handleReviewAndSubmit();
          }}
        >
          {i18n['Review & Submit']}
        </Button>
      </Styled.ButtonWrapper>

      {showTCAcceptedModal && (
        <ITeroTermsConditionsModal
          onAccept={(approvedPdf: string) => {
            handlePlaceIteroOrder(approvedPdf);
          }}
          onClose={() => {
            setShowTCAcceptedModal(false);
          }}
          additionalOrderInfo={additionalOrderInfo}
          selectedScannerSubFundingSource={selectedScannerSubFundingSource}
          selectedShippingAddress={selectedShippingAddress}
          selectedBillingAddress={selectedBillingAddress}
          doctorProfile={doctorProfile}
          currentProposal={currentProposal}
          selectedCreditCard={selectedCreditCard}
        />
      )}
    </Styled.IteroTCContainer>
  );
};

export default ITeroTermsAndConditions;
